"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTreeNodesWithValidators = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const gql_1 = require("../gql");
const useGetTreeNodesWithValidators = ({ productTreeId, filter, attributesFilter, options, }) => {
    const _a = (0, react_2.useQuery)(gql_1.GET_ALL_PRODUCT_TREE_NODES_WITH_VALIDATORS, {
        variables: {
            productTreeId,
            filter,
            skipValidators: !attributesFilter,
            attributesFilter,
            first: 2000, // TODO: reduce it when implement search
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        skip: options === null || options === void 0 ? void 0 : options.skip,
    }), { data } = _a, queryResponse = __rest(_a, ["data"]);
    const formattedData = (0, react_1.useMemo)(() => { var _a, _b, _c; return (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.productTreeNodes) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.map((item) => item.node)) !== null && _c !== void 0 ? _c : []; }, [data]);
    return Object.assign({ data: formattedData }, queryResponse);
};
exports.useGetTreeNodesWithValidators = useGetTreeNodesWithValidators;
exports.default = exports.useGetTreeNodesWithValidators;
